/** Server-owned Home Chat shell mode. Client parsing is presentation-only. */
export type HomeChatMode = 'full' | 'workflow_only' | 'none';

/**
 * Accept only the public enum. Older servers did not send the field: retain
 * their established full-chat behavior only when their legacy entitlement
 * explicitly permits it. A constrained caller never receives an inferred
 * workflow-only grant from a missing or unknown value.
 */
export function parseHomeChatMode(
  value: unknown,
  legacyCanUseChatbot: boolean,
): HomeChatMode {
  if (value === 'full' || value === 'workflow_only' || value === 'none') return value;
  return legacyCanUseChatbot ? 'full' : 'none';
}
